"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

var _ravenJs = _interopRequireDefault(require("raven-js"));

var _version = _interopRequireDefault(require("../../constants/version"));

var _config = require("../../utils/config");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

var report = function report(next) {
  return function (params) {
    var _getConfig = (0, _config.getConfig)(),
        isReport = _getConfig.isReport,
        serviceId = _getConfig.serviceId; // 一般来说生产环境才需要上报


    if (!isReport) return true;

    var _onSuccess = params.onSuccess,
        _onError = params.onError,
        originalData = params.originalData,
        others = _objectWithoutProperties(params, ["onSuccess", "onError", "originalData"]); // 将serviceId传递到server做日志访问


    var nextOthers = Object.assign({}, others, {
      auth: {
        service_id: serviceId,
        kepler_version: _version.default
      }
    });
    var nextParams = Object.assign({}, nextOthers, {
      onSuccess: function onSuccess() {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _onSuccess && _onSuccess.apply(_ravenJs.default, args);
        next({
          data: originalData,
          success: true
        });
      },
      onError: function onError() {
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        _onError && _onError.apply(_ravenJs.default, args);
        next({
          data: originalData,
          success: false
        });
      }
    });
    return _ravenJs.default._makeRequest(nextParams);
  };
};

var _default = report;
exports.default = _default;